import { useCallback, useRef } from 'react';

/**
 * Accepts an action right away, then ignores repeats for `durationMs`.
 *
 * Returns `allowAction`: call it at the start of a handler and bail out when it returns
 * false. Only accepted actions start the cooldown, so a re-render or a status change never
 * blocks the next click.
 */
export function useActionCooldown(durationMs: number): () => boolean {
  const lastAcceptedAt = useRef<number | null>(null);

  return useCallback(() => {
    const now = Date.now();
    if (lastAcceptedAt.current != null && now - lastAcceptedAt.current < durationMs) {
      return false;
    }
    lastAcceptedAt.current = now;
    return true;
  }, [durationMs]);
}
